/* eslint-disable */
import { gql } from 'graphql-tag';
import { v4 as uuidv4 } from 'uuid';
import { store } from '@store/store';

export const parseOperationName = (query: string): string => {
  const obj = gql(query);
  // @ts-ignore
  return obj.definitions[0].name.value as string;
};

// We use a custom fetcher so that we can manually pass in
// the operation name to the JSON to be consumed by metrics
export function fetcher<TData, TVariables>(query: string, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch('https://api.us-west-2.beta.categorymanagement.wwgs.amazon.dev/graphql' as string, {
      method: 'POST',
      ...{
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'x-amzn-RequestId': uuidv4(),
          // Can't use useAppSelector(selectProgram) here because this is not a functional component
          'x-cmt-program-name': store.getState().program.selectedProgram ?? '',
        },
      },
      body: JSON.stringify({
        query,
        variables,
        operationName: parseOperationName(query),
      }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  };
}
